import { useEffect, useRef } from 'react';

export const NonScrollingInput = (props) => {
  const inputRef = useRef(null);
  const { saverMethod, labelerMethod } = props;
  const { annotation, onCreateBody, onUpdateBody } = props;

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus({ preventScroll: true });
    }
  }, []);

  return (
    <div>
      <input ref={inputRef} {...props} onChange={e => labelerMethod(e.target.value)} onBlur={e => saverMethod(inputRef, props, e.target.value)} />
    </div>
  );
};

export default NonScrollingInput;
